<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  appendTo="body"
  placeholder="Izaberite"
  (onChange)="selectedItemsOnChange()"
></p-multiSelect>
